// test1246
(1246 && 0);
